import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ElectoralCoalitionComponent } from "./electoral-coalition.component";
import { TranslateModule } from "@ngx-translate/core";
import { TableModule } from '@valg-shared/components/table/table.module';
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        TableModule,
    ],
  declarations: [
    ElectoralCoalitionComponent
  ],
  exports: [
    ElectoralCoalitionComponent
  ]
})
export class ElectoralCoalitionModule {}
